module.exports = __webpack_public_path__ + "static/media/khu.91c3d118.ogg";